import ExportMenu from "../../Common/ExportMenu/ExportMenu";
import { useRfidReportsExcelExport } from "./ExportRfidReportsExcel";
import { useRfidReportsPdfExport } from "./ExportRfidReportsPdf";

export const ExportRfidReports = ({ rfidReportData = [] }) => {
  const excel = useRfidReportsExcelExport(rfidReportData);
  const pdf = useRfidReportsPdfExport(rfidReportData);

  return (
    <div className="ms-3">
      <ExportMenu
        items={[
          {
            label: "Excel",
            icon: "fa-solid fa-file-excel",
            onClick: excel.exportToExcel,
            loading: excel.isExporting,
          },
          {
            label: "PDF",
            icon: "fa-solid fa-file-pdf",
            onClick: pdf.exportToPDF,
            loading: pdf.isExporting,
          },
        ]}
      />
    </div>
  );
};
